<template>
	<div :class="{
		'game-bg': $route.path === '/games/game' || $route.path === '/demo/game',
		preview: !!preview,
	}" class="games-wrapper" :style="{
		backgroundImage: primaryBackground
			? `url(${appMode ? 'https://api.dev.indigomental.com' : ''
			}${primaryBackground})!important`
			: undefined,
		backgroundRepeat: 'no-repeat',
		backgroundPosition: primaryBackground ? `0 0!important` : undefined,
		backgroundSize: 'cover',
	}">
		<div class="logo-block">
			<div class="logo">
				<div @click="$router.go(-1)" class="back-btn">
					<svg fill="#FFFFFF" height="35px" width="35px" viewBox="0 0 26.676 26.676">
						<g>
							<path d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59
		c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815
		C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029
		c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562
		C26.18,21.891,26.141,21.891,26.105,21.891z" />
						</g>
					</svg>
				</div>

				<img src="../../assets/logo_en.svg" style="height: 50px" class="img-fluid" alt="" />
			</div>
		</div>

		<ListDemo v-if="isDemoListPage" @openTutorial="showTutorial = true" />
		<router-view v-else-if="!preview"></router-view>
		<List v-else :disabled="true" />
		<Character v-if="loaded && !preview" mode="games" />
		<Tutorial v-if="isDemo && showTutorial" @close="showTutorial = false" />
	</div>
</template>

<script>
import Character from './UI/Character'
import Tutorial from './Tutorial'
import List from './List'
import ListDemo from './ListDemo'
import { getTime } from '@/helpers/getTime'

export default {
	name: 'games-wrapper',
	data: () => ({
		loaded: false,
		showTutorial: false,
		appMode: false, //process.env.VUE_APP_ENV == 'dev',
	}),
	props: ['preview'],
	computed: {
		primaryBackground() {
			return this.preview || this.$store.getters.primaryBackground
		},
		isDemoListPage() {
			return this.$route.path === '/demo'
		},
		isDemo() {
			return this.$route.path.startsWith('/demo')
		},
	},
	created() {
		if (!this.isDemo) {
			if (!localStorage.getItem('totalPlayed') || !localStorage.getItem('totalRight')) {
				const date = getTime()
				const day = date.day
				const month = date.month
				const year = date.year
				this.axios({
					method: 'get',
					url: `lessons/game/data/statistic?day=${day}&month=${month}&year=${year}&user=${this.$store.state.myProfile.id}`,
				}).then(response => {
					localStorage.setItem('totalPlayed', response.data.all_time.total)
					localStorage.setItem('totalRight', response.data.all_time.total_right)
					this.loaded = true
				})
			} else {
				this.loaded = true
			}
		}
	},
	components: {
		Character,
		List,
		ListDemo,
		Tutorial,
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.games-wrapper {
	& .input-number {
		input[type=number] {
			appearance: textfield;
			-moz-appearance: textfield;
		}

		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}

	& .level-block {
		display: grid !important;
		grid-template-columns: 72% 23% !important;
		grid-gap: 6px !important;

		&.anzan {
			display: block !important;
			margin-right: 10px;
		}
	}

	& .level-type {
		width: 100% !important;
		text-align: left;
		padding-left: 20px;
	}

	& .form-check {
		margin-bottom: 5px;
	}

	& .sound-block {
		width: 300px;

		margin-left: 20px;

		display: flex;
		align-items: center;

		@media (max-width: 767px) {
			flex-direction: column;
		}

		& .custom-select {
			width: 60px;
			padding: 6px;
			background: none;

			margin: 0 6px;
		}
	}

	& .sound-control {
		margin-right: 10px;

		& label {
			margin: 0;
		}
	}

	@media (max-width: 767px) {
		& .base-list {
			text-align: center;
		}

		& .form-inline {
			justify-content: center;
		}

		& .form-check {
			display: inline-block;
			margin: 5px;
		}

		& .check-list {
			text-align: center;
		}
	}
}

.games-wrapper .setting-name {
	font-size: 18px;

	margin: 12px 0 0;

	@media (max-width: 767px) {
		margin: 20px 0 10px;
	}
}

.games-wrapper .digits-field {
	display: flex;
	justify-content: space-between;
	border: 2px solid #6f42c1;

	padding: 30px 0;
	width: 320px;

	border-radius: 12px;

	& input[type='radio'] {
		width: 15px;
		height: 15px;

		margin-right: 5px;

		accent-color: #6f42c1;
	}

	&.anzan {
		width: 190px !important;
		justify-content: center !important;
		padding: 10px 18px !important;
	}

	@media (max-width: 767px) {
		width: 100% !important;
	}
}

.games-wrapper .block {
	display: grid;
	grid-template-columns: 40% 60%;
	grid-gap: 15px;

	width: 610px;
	padding: 30px;
	margin: auto;

	@media (max-width: 767px) {
		width: 100% !important;
		margin: 15px !important;

		display: flex !important;
		flex-direction: column !important;
		align-items: center !important;
		text-align: center !important;
	}

	@media (max-width: 430px) {
		width: 100% !important;
		padding: 10px !important;
		margin: 0 !important;

		// display: flex !important;
		// flex-direction: column !important;
		// align-items: center !important;
		// text-align: center !important;
	}
}

.games-wrapper .highlighted-content {
	background: #fff;
	border-radius: 12px;

	color: #212529;

	box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);

	transform-origin: top center;

	@media (max-width: 430px) {
		border-radius: 0% !important;
	}
}

/* & h6 {
	margin: 0;
} */

.back-btn {

	background-color: #e4467b;
	width: 50px;
	height: 50px;

	cursor: pointer;

	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
}

.logo-block {
	width: 100%;
}

.logo {
	position: relative;
	display: flex;
	justify-content: space-between;
	padding: 20px 0;
	width: 235px;

	margin-left: auto;
	margin-right: auto;
}

.logo img {
	padding: 10px;
	background-color: #ffffff;
	display: block;
	border-radius: 8px;
}

.logo svg {
	display: block;
	margin: auto;
	margin-top: 5px;
}

#app .games-wrapper {
	min-height: 100vh;
	color: #fff;
	background: #494da2 url(../../assets/back.png) center 0 no-repeat;
	-webkit-background-size: auto 100%;
	background-size: auto 100%;
}

#app .games-wrapper.preview {
	min-height: unset;
	overflow: auto;
}

#app .games-wrapper.preview * {
	pointer-events: none;
}

#app .games-wrapper.game-bg {
	background: #494da2 url(../../assets/back-white.png) center 0 no-repeat;
}

.games-wrapper .btn-actions {
	margin-top: 25px;

	text-align: center;
	grid-column-start: 1;
	grid-column-end: 3;
}

.games-wrapper .btn-blue {
	display: inline-block;
	margin: 3px;
	background: #6f42c1;
	/* background: #162078; */
	color: white;
	text-align: center;

	height: 40px;
	width: 40px;

	border-radius: 8px;
}

.games-wrapper .btn-success {
	height: 45px;
	width: 100px;
	margin: 10px 15px;
}

.games-wrapper input[type='number'] {
	width: 60px;
	height: 42px;
	border: 2px solid #6f42c1;
	border-radius: 12px;
	/* border: 1px solid #ced4da; */
	border-radius: 12px;
	color: #6f42c1;
	text-align: center;
	margin: 3px 20px;

	&:disabled {
		opacity: 0.7;
	}
}

.games-wrapper select {
	/* width: 60px;
	height: 42px; */
	border: 2px solid #6f42c1;
	border-radius: 12px;
	/* border: 1px solid #ced4da; */
	border-radius: 12px;
	color: #6f42c1;
	text-align: center;

}

.games-wrapper hr {
	height: 2px;
	width: 55px;
	background: #f3b12d;
	display: block;
	margin: 10px 0;
	margin-bottom: 20px;
}

.games-wrapper h6 {
	font-size: 20px;
	margin: 20px 0;
}

.games-wrapper .complexity {
	/* background-color: #e4467b; */
	border: 2px solid #6f42c1;
	height: 40px;
	color: #6f42c1;
	width: 60px;

	margin-right: 5px;

	border-radius: 12px;

	font-size: 16px;
	font-weight: bold;
	line-height: 40px;
	cursor: pointer;
}

.games-wrapper .complexity:hover,
.games-wrapper .complexity.active {
	background-color: #6f42c1;
	color: #fff;
}

.games-wrapper .complexity-list {
	/* padding: 10px; */
	/* max-width: 300px; */
	/* justify-content: space-between; */

	display: flex;
	/* flex-wrap: wrap; */
}

@media (max-width: 767px) {
	.games-wrapper hr {
		display: inline-block;
	}

	.games-wrapper .complexity-list {
		align-items: center;
		// width: 100%;
		max-width: 100%;
		margin: 0;
	}
}
</style>
